var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalFan1OnOff = function SvgDAhuSignalFan1OnOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 105,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,95c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S218.5,95,224,95 M224,94c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S230.1,94,224,94L224,94z",
    fill: "#1C9D5B"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224,112.6c-4.2,0-7.6-3.4-7.6-7.6c0-2.4,1.1-4.7,3-6.1l0.6,0.8c-1.7,1.3-2.6,3.2-2.6,5.3c0,3.7,2.9,6.6,6.6,6.6 s6.6-3,6.6-6.6c0-2.1-1-4.1-2.6-5.3l0.6-0.8c1.9,1.5,3,3.7,3,6.1C231.6,109.1,228.2,112.6,224,112.6L224,112.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.5,
    y: 96.4,
    width: 1,
    height: 7.1
  }))))));
};
export default SvgDAhuSignalFan1OnOff;